import { useEffect, useState } from 'react';

import { apiRequest, getApiUrl } from '../config/api';

// Una petición por sesión: las reglas solo cambian con un despliegue.
let promesa = null;

const cargar = () => {
  if (!promesa) {
    promesa = apiRequest(getApiUrl('/media/reglas'))
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .catch(() => {
        promesa = null; // el siguiente montaje reintenta
        return null;
      });
  }
  return promesa;
};

export const _olvidarReglasMedia = () => { promesa = null; };

export default function useReglasMedia() {
  const [reglas, setReglas] = useState(null);
  useEffect(() => {
    let vivo = true;
    cargar().then((r) => { if (vivo) setReglas(r); });
    return () => { vivo = false; };
  }, []);
  return reglas;
}
